import React, { createContext, Component } from "react";
import mqtt from "mqtt";

export const MqttContext = createContext();

const MQTT_BROKER_URL = "wss://mqtt.3dvam.info";

const MQTT_OPTIONS = Object.freeze({
  protocolVersion: 5,
  username: "papinaga",
  password: "Cideng87(",
  reconnectPeriod: 2000,
  keepalive: 30,
  clean: true,
  clientId: `mqtt_${Math.random().toString(16).slice(3)}`,
});

export class MqttProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      client: null,
      isConnected: false,
      messagesTopicTicket: [],
      messagesTopicNotification: [],
      messagesTradeDataEURUSD: [],
      messagesTradeDataHREU: [],
      messagesTradeChartEURUSD: [],
      messagesTradeDataBTCUSDc: [],
      messagesTradeChartBTCUSDc: [],
      messagesTradeDataXAUUSDc: [],
      messagesTradeChartXAUUSDc: [],
      messagesBalancerServer: "",
      messagesBalancerServer2: "",
      messagesClientGUI: null,
      messagesAccountMetric: {},
      messagesAccountProfitToday: {},
      messagesTradeDataV2: {},
    };

    this._subscriptions = new Set();
    this._isMounted = false;
    this._boundHandlers = [];
  }

  deepEqual = (a, b) => {
    return JSON.stringify(a) === JSON.stringify(b);
  };

  _bind = (emitter, event, handler) => {
    emitter.on(event, handler);
    this._boundHandlers.push({ emitter, event, handler });
  };

  componentDidMount() {
    this._isMounted = true;

    const mqttClient = mqtt.connect(MQTT_BROKER_URL, MQTT_OPTIONS);

    this._bind(mqttClient, "connect", () => {
      if (!this._isMounted) return;
      this.setState({ isConnected: true, client: mqttClient });

      if (this._subscriptions.size) {
        mqttClient.subscribe([...this._subscriptions], (err) => {
          if (err) console.error("Resubscribe error:", err);
        });
      }
    });

    this._bind(mqttClient, "reconnect", () => {
      if (!this._isMounted) return;
      // status reconnect → masih mencoba
      this.setState({ isConnected: false });
    });

    this._bind(mqttClient, "offline", () => {
      if (!this._isMounted) return;
      this.setState({ isConnected: false });
    });

    this._bind(mqttClient, "close", () => {
      if (!this._isMounted) return;
      this.setState({ isConnected: false });
    });

    this._bind(mqttClient, "end", () => {
      if (!this._isMounted) return;
      this.setState({ isConnected: false });
    });

    this._bind(mqttClient, "error", (err) => {
      console.error("Connection error:", err);
    });

    this._bind(mqttClient, "message", (topic, message) => {
      let parsedMessage = null;
      try {
        const text =
          message && typeof message.toString === "function"
            ? message.toString()
            : "";
        parsedMessage = text ? JSON.parse(text) : null;
      } catch (e) {
        return;
      }
      if (!this._isMounted || parsedMessage === null) return;

      const profitMatch = topic.match(/^Account\/(\d+)\/profit\/utcp0$/);
      if (profitMatch) {
        const account = profitMatch[1];
        this.setState((prevState) => ({
          messagesAccountProfitToday: {
            ...prevState.messagesAccountProfitToday,
            [account]: parsedMessage,
          },
        }));
        return;
      }

      const tradeDataMatch = topic.match(/^TradedataV2\/(\d+)\/([\w\d]+)/);
      if (tradeDataMatch) {
        const account = tradeDataMatch[1];
        const symbol = tradeDataMatch[2];
        const key = `${account}_${symbol}`;
        this.setState((prevState) => ({
          messagesTradeDataV2: {
            ...prevState.messagesTradeDataV2,
            [key]: parsedMessage,
          },
        }));
        return;
      }

      if (topic.includes("ticket")) {
        if (!this.deepEqual(this.state.messagesTopicTicket, parsedMessage)) {
          this.setState({ messagesTopicTicket: parsedMessage });
        }
        return;
      }

      if (topic.includes("notification")) {
        if (
          !this.deepEqual(this.state.messagesTopicNotification, parsedMessage)
        ) {
          this.setState({ messagesTopicNotification: parsedMessage });
        }
        return;
      }

      if (topic.startsWith("Account/") && topic.endsWith("/metricOntick")) {
        const match = topic.match(/Account\/(\d+)\/metricOntick/);
        if (match) {
          const accountNumber = match[1];
          this.setState((prevState) => ({
            messagesAccountMetric: {
              ...prevState.messagesAccountMetric,
              [accountNumber]: parsedMessage,
            },
          }));
        }
        return;
      }

      if (topic.includes("TradechartV2/EURUSD")) {
        if (
          !this.deepEqual(this.state.messagesTradeChartEURUSD, parsedMessage)
        ) {
          this.setState({ messagesTradeChartEURUSD: parsedMessage });
        }
        return;
      }

      if (topic.includes("TradedataV2/69664448/XAUUSDm")) {
        if (!this.deepEqual(this.state.messagesTradeDataHREU, parsedMessage)) {
          this.setState({ messagesTradeDataHREU: parsedMessage });
        }
        return;
      }

      if (topic.includes("TradedataV2/117117224/EURUSD")) {
        if (
          !this.deepEqual(this.state.messagesTradeDataEURUSD, parsedMessage)
        ) {
          this.setState({ messagesTradeDataEURUSD: parsedMessage });
        }
        return;
      }

      if (topic.includes("TradechartV2/BTCUSDc")) {
        if (
          !this.deepEqual(this.state.messagesTradeChartBTCUSDc, parsedMessage)
        ) {
          this.setState({ messagesTradeChartBTCUSDc: parsedMessage });
        }
        return;
      }

      if (topic.includes("TradedataV2/159018075/BTCUSDc")) {
        if (
          !this.deepEqual(this.state.messagesTradeDataBTCUSDc, parsedMessage)
        ) {
          this.setState({ messagesTradeDataBTCUSDc: parsedMessage });
        }
        return;
      }

      if (topic.includes("TradechartV2/XAUUSDc")) {
        if (
          !this.deepEqual(this.state.messagesTradeChartXAUUSDc, parsedMessage)
        ) {
          this.setState({ messagesTradeChartXAUUSDc: parsedMessage });
        }
        return;
      }

      if (topic.includes("TradedataV2/141055910/XAUUSDc")) {
        if (
          !this.deepEqual(this.state.messagesTradeDataXAUUSDc, parsedMessage)
        ) {
          this.setState({ messagesTradeDataXAUUSDc: parsedMessage });
        }
        return;
      }

      if (topic.includes("Balancer/MT4/Server-GUI/3")) {
        if (!this.deepEqual(this.state.messagesBalancerServer, parsedMessage)) {
          this.setState({ messagesBalancerServer: parsedMessage });
        }
        return;
      }

      if (topic.includes("Balancer/MT5/Server-GUI/3")) {
        if (!this.deepEqual(this.state.messagesBalancerServer, parsedMessage)) {
          this.setState({ messagesBalancerServer: parsedMessage });
        }
        return;
      }

      if (topic.includes("Balancer/MT5/Server-GUI/2")) {
        if (
          !this.deepEqual(this.state.messagesBalancerServer2, parsedMessage)
        ) {
          this.setState({ messagesBalancerServer2: parsedMessage });
        }
        return;
      }

      if (topic.includes("Balancer/MT4/Server-GUI/2")) {
        if (
          !this.deepEqual(this.state.messagesBalancerServer2, parsedMessage)
        ) {
          this.setState({ messagesBalancerServer2: parsedMessage });
        }
        return;
      }

      if (topic.includes("Client-GUI")) {
        if (!this.deepEqual(this.state.messagesClientGUI, parsedMessage)) {
          this.setState({ messagesClientGUI: parsedMessage });
        }
        return;
      }
    });

    this.setState({ client: mqttClient });
  }

  componentWillUnmount() {
    this._isMounted = false;

    const { client } = this.state;
    if (client) {
      try {
        client.end(true);
      } catch (e) {}
    }
  }

  resetMessages = () => {
    this.setState({
      messagesBalancerServer: "",
      messagesBalancerServer2: "",
      messagesClientGUI: null,
    });
  };

  subscribeToTopic = (topic) => {
    const { client } = this.state;
    if (!client) {
      console.error("MQTT client not connected, can't subscribe");
      return;
    }
    this._subscriptions.add(topic);

    client.subscribe(topic, { qos: 0 }, (err) => {
      if (err) {
        console.error(`Error subscribing to ${topic}:`, err);
      } else {
        // console.log(`Successfully subscribed to ${topic}`);
      }
    });
  };

  unsubscribeFromTopic = (topic) => {
    const { client } = this.state;
    this._subscriptions.delete(topic);

    if (!client) {
      console.error("MQTT client not connected, can't unsubscribe");
      return;
    }

    client.unsubscribe(topic, (err) => {
      if (err) {
        console.error(`Error unsubscribe to ${topic}:`, err);
      } else {
        // console.log(`Successfully unsubscribe to ${topic}`);
      }
    });
  };

  publishMessage = (topic, message) => {
    const { client } = this.state;
    if (!client) {
      console.error("MQTT client not connected, can't publish");
      return;
    }

    let payload;
    try {
      payload =
        typeof message === "object" ? JSON.stringify(message) : String(message);
    } catch (e) {
      console.error("Publish payload stringify error:", e);
      return;
    }

    client.publish(topic, payload, { qos: 0, retain: false }, (err) => {
      if (err) {
        console.error("Publish error:", err);
      } else {
        // console.log("Publish successful");
      }
    });
  };

  render() {
    const {
      client,
      isConnected,
      messagesTopicNotification,
      messagesTopicTicket,
      messagesTradeDataHREU,
      messagesTradeDataEURUSD,
      messagesTradeChartEURUSD,
      messagesTradeDataBTCUSDc,
      messagesTradeChartBTCUSDc,
      messagesTradeChartXAUUSDc,
      messagesTradeDataXAUUSDc,
      messagesBalancerServer,
      messagesBalancerServer2,
      messagesClientGUI,
      messagesAccountMetric,
      messagesAccountProfitToday,
      messagesTradeDataV2,
    } = this.state;

    return (
      <MqttContext.Provider
        value={{
          client,
          isConnected,
          messagesTopicNotification,
          messagesTopicTicket,
          messagesTradeDataEURUSD,
          messagesTradeDataHREU,
          messagesTradeChartEURUSD,
          messagesTradeDataBTCUSDc,
          messagesTradeChartBTCUSDc,
          messagesTradeChartXAUUSDc,
          messagesTradeDataXAUUSDc,
          messagesBalancerServer,
          messagesBalancerServer2,
          messagesClientGUI,
          messagesAccountMetric,
          messagesAccountProfitToday,
          messagesTradeDataV2,
          resetMessages: this.resetMessages,
          subscribeToTopic: this.subscribeToTopic,
          publishMessage: this.publishMessage,
          unsubscribeFromTopic: this.unsubscribeFromTopic,
        }}
      >
        {this.props.children}
      </MqttContext.Provider>
    );
  }
}
